export const APPID = 'APPID'
export const IS_ADMIN = 'IS_ADMIN'
export const ROUTE_NAME = 'ROUTE_NAME'
export const APP_HANDLE_FLAG = 'APP_HANDLE_FLAG'
export const MEDIA_LIST_PAGE = 'MEDIA_LIST_PAGE' // 媒体列表page
export const MEDIA_CLASSIFY_ID = 'MEDIA_CLASSIFY_ID' // 媒体页分类id
export const MEDIA_STATUS_ID = 'MEDIA_STATUS_ID' // 状态
export const USER_STATUS_ID = 'USER_STATUS_ID' // 状态
export const RECEIPT_STATUS_ID = 'RECEIPT_STATUS_ID' // 状态